module.exports = __webpack_public_path__ + "static/media/zenthly.fe24107d.png";